<script>
  import { Item } from 'lt-gallery';

  import { chainId } from '../stores.js';

  import { getContractJSONvalue } from '../utils.js';

  export let chain;
  export let address;
  export let tokenId;
  export let layout;

  let values;

  $: $chainId, init();

  const init = async () => {
    if ($chainId) {
      if (typeof layout === 'string') {
        const resp = await fetch(layout);
        if (resp.ok) {
          layout = await resp.json();
        }
      }

      values = await getContractJSONvalue(chain, address, tokenId);
    }
  }
</script>

{#if values}
  <Item { layout } { values } />
{:else}
  Loading...
{/if}